var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(list,i){return _c('div',{key:i,staticClass:"text-left px-6 my-2"},[_c('div',{staticClass:"font-bond text-xl"},[_vm._v(" "+_vm._s(list.title)+" ")]),_c('items',{attrs:{"items":list.items}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }